export default __webpack_public_path__ + "static/media/Sintony.fe57fe1b.woff";